import React from "react";
import styles from "./Loader.module.scss";

const Loader = ({ minHeight, minWidth, colored, small }) => {
  return (
    <div
      className={`${styles.inPlaceLoader} ${
        colored && styles["inPlaceLoader--colored"]
      } ${small && styles["inPlaceLoader--small"]}`}
      style={{
        minHeight: `${minHeight || 48}px`,
        minWidth: `${minWidth || 48}px`,
      }}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
